var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AptiveIcon, Loading } from '@aptive-env/storybook';
import { getRouteHistory } from 'services/scheduling';
import { format } from 'date-fns';
var RouteHistory = function (_a) {
    var routeId = _a.routeId, officeId = _a.officeId, date = _a.date;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState([]), historyData = _c[0], setHistoryData = _c[1];
    var getDotColor = function (status) {
        switch (status) {
            case 'created':
            case 'added':
                return 'bg-green-500';
            case 'removed':
            case 'rescheduled':
                return 'bg-red-500';
            case 'optimized':
                return 'bg-yellow-500';
            default:
                return 'bg-gray-500';
        }
    };
    var formatDateTime = function (timestamp) { return ({
        date: format(new Date(timestamp), 'd MMM'),
        time: format(new Date(timestamp), 'h:mm a')
    }); };
    var getStatus = function (type) {
        var statusMap = {
            'route-created': 'created',
            'optimization-run': 'optimized',
            'appointment-removed': 'removed',
            'appointment-added': 'added',
        };
        return statusMap[type] || 'unknown';
    };
    var getDetails = function (entry) {
        var _a;
        switch (entry.type) {
            case 'route-created':
                return ((_a = entry.route) === null || _a === void 0 ? void 0 : _a.added_by) || 'Route details unavailable';
            case 'optimization-run':
            case 'appointment-removed':
            case 'appointment-added':
                return (entry === null || entry === void 0 ? void 0 : entry.triggered_by) || 'Route details unavailable';
            default:
                return 'Route details unavailable';
        }
    };
    useEffect(function () {
        setIsLoading(true);
        getRouteHistory(routeId, officeId, date)
            .then(function (response) {
            console.log('response', response);
            var data = response.result.map(function (entry, index) { return (__assign(__assign({ id: index + 1 }, formatDateTime(entry.timestamp)), { title: entry.description, details: getDetails(entry), status: getStatus(entry.type), metrics: entry.optimization ? [
                    { value: entry.optimization.optimization_score },
                ] : undefined })); });
            setHistoryData(data);
            setIsLoading(false);
        });
    }, [date, officeId, routeId]);
    return (_jsxs("div", __assign({ className: "h-full bg-white px-4 py-3 relative overflow-auto" }, { children: [_jsxs("div", __assign({ className: "flex justify-between font-inter text-gray-700 font-medium text-xs leading-[18px]" }, { children: [_jsx("p", { children: "Route History" }), _jsx("p", { children: "Optimization%" })] })), isLoading ? (_jsx("div", __assign({ className: "flex items-center justify-center h-full" }, { children: _jsx(Loading, {}) }))) : (_jsx("div", { children: historyData.map(function (data) { return (_jsxs("div", __assign({ className: "flex justify-between items-start ".concat(data.id === 1 ? 'mt-4' : '-mt-1') }, { children: [_jsxs("div", __assign({ className: "flex justify-between items-start gap-3" }, { children: [_jsxs("div", __assign({ className: "w-[80px] flex justify-end items-start gap-3" }, { children: [_jsxs("div", __assign({ className: "flex flex-col justify-between" }, { children: [_jsx("div", __assign({ className: "text-sm font-inter text-gray-500 font-semibold text-right" }, { children: data.date })), _jsx("div", __assign({ className: "text-sm font-inter text-gray-500 font-semibold text-left" }, { children: data.time }))] })), _jsxs("div", __assign({ className: 'flex flex-col items-center gap-y-1 mt-2' }, { children: [_jsx("div", { className: "w-[5px] h-[5px] rounded-full ".concat(data, " ").concat(getDotColor(data.status)) }), data.id < historyData.length && (_jsx("div", { className: "w-px h-[62px] bg-gray-300" }))] }))] })), _jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("div", __assign({ className: "text-sm font-inter font-semibold w-[222px]" }, { children: data.title })), _jsx("div", __assign({ className: "text-sm font-inter font-normal text-gray-500" }, { children: data.details }))] }))] })), data.metrics && (_jsx("div", __assign({ className: "flex items-center gap-1" }, { children: data.metrics.map(function (metric, index) { return (_jsxs("div", __assign({ className: "flex items-center gap-1 mt-3" }, { children: [_jsx("div", __assign({ className: "flex justify-center w-5 h-5 ".concat(metric.value > 90 ? 'bg-[#DEF7EC]' : 'bg-[#FDF6B2]', " border ").concat(metric.value > 90 ? 'border-[#057A55]' : 'border-[#8E4B10]', " rounded-full items-center") }, { children: _jsx("span", __assign({ className: "font-inter font-semibold text-[10px] leading-3 ".concat(metric.value > 90 ? 'text-[#057A55]' : 'text-[#8E4B10]') }, { children: metric.value })) })), 'icon' in metric && metric.icon && (_jsx(AptiveIcon, { className: "w-[10px] h-[10px] fill-gray-500 stroke-none", icon: "".concat(metric.icon === 'up' ? 'arrowNarrowUp' : 'arrowNarrowDown'), isFilled: true }))] }), index)); }) })))] }), data.id)); }) }))] })));
};
export default RouteHistory;
